import type { ReactComponent } from '@main/core-ui';
import { PageType } from '@main/pc-types';

import CommunicationsPreferences from './CommunicationsPreferences';
import { HomePage } from './HomePage';
import ManageYourPrivacy from './ManageYourPrivacy/Loadable';
import Policies from './Policies/Loadable';
import RequestsProcessedReporting from './RequestsProcessedReporting/Loadable';
import SaleOfInfo from './SaleOfInfo/Loadable';
import TrackingTechnologies from './TrackingTechnologies/Loadable';

/**
 * The privacy center page containers
 */
const PAGES: { [type in PageType]: ReactComponent } = {
  [PageType.ManageYourPrivacy]: ManageYourPrivacy,
  [PageType.HomePage]: HomePage,
  [PageType.Policies]: Policies,
  [PageType.TrackingTechnologies]: TrackingTechnologies,
  [PageType.RequestsProcessedReporting]: RequestsProcessedReporting,
  [PageType.CommunicationsPreferences]: CommunicationsPreferences,
  [PageType.SaleOfInfo]: SaleOfInfo,
};
export default PAGES;
